module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"like_text":"Helpful","unlike_text":"Unhelpful","already_submitted":"You have already liked or unliked this review. Please refresh your browser :)","comment":"Comments"}}')
  delete Component.options._Ctor
}
